import {
  getJobsService,
  deleteJobsService,
  editJobService,
  createJobService,
  getJobByIdService,
  getJobStatsByIdService,
  getJobStatsByUserIdService,
} from 'services';
import { getAuthorization, getStore, dispatch } from './controller';
import {
  SET_JOB_LISTING,
  UPDATE_SELECTED_JOB,
  SET_SELECTED_JOB,
  RESET_SELECTED_JOB,
  ADD_COLLEGE,
  REMOVE_COLLEGE,
  REMOVE_DOMAIN,
  ADD_DOMAIN,
} from 'actions/constants';
import { setFlag } from './flags';

export const getjobs = async (page = 'false', filter, userId) => {
  const prevPage = getStore().job.listing.currentPage;
  const selectedPage = page !== 'false' ? page : prevPage;

  resetJoblist();

  const authorization = getAuthorization();
  const search = {
    page: selectedPage || 0,
    size: 10,
    filter: Boolean(filter && Object.keys(filter).length),
  };
  const uid = getStore().user.details.userId;
  const { status, data } = await getJobsService(
    authorization,
    uid,
    search,
    filter
  );

  let contentPromise = data.response.content.map((job) =>
    getJobStatsByIdService(authorization, job.jobId).then(({ data }) => {
      const jobStatusCounts = {};
      const { totalApplicants, totalLeads, totalScreened } = data.response;
      jobStatusCounts['totalCandidates'] = totalScreened;
      jobStatusCounts['leadsCount'] = totalLeads;
      jobStatusCounts['appliedCount'] = totalApplicants;

      return {
        ...job,
        ...jobStatusCounts,
      };
    })
  );

  data.response.content = await Promise.all(contentPromise);
  const jobStatsData = await getJobStatsByUserIdService(authorization, userId);
  const stats = {};
  if (jobStatsData.data.response && Array.isArray(jobStatsData.data.response)) {
    jobStatsData.data.response.forEach((job) => {
      const jobStatus = job.jobStatus.toLowerCase();
      stats[jobStatus] = job.count;
    });
  }
  dispatch({
    type: SET_JOB_LISTING,
    listing: {
      ...data.response,
      stats,
    },
  });

  if (status !== 200) {
    console.error('Error', status);
    return false;
  }

  return data;
};

export const resetJoblist = () => {
  dispatch({
    type: SET_JOB_LISTING,
    listing: {},
  });
};

export const deleteJobs = async (jobids) => {
  const authorization = getAuthorization();

  const { status } = await deleteJobsService(authorization, jobids);

  if (status !== 200) {
    console.error('Error', status);
    return false;
  }

  if (jobids.length > 1) {
    setFlag('deleteJobs', true);
  } else {
    setFlag('deleteJob', true);
  }

  return true;
};

export const editJob = async (details) => {
  const authorization = getAuthorization();
  const {
    organizationInfo: { organizationId },
  } = getStore().user.details;
  let jobDetails = {};
  if (!details || Object.keys(details).length === 0) {
    const selectedJob = getStore().job.selectedJob;
    jobDetails = {
      ...jobDetails,
      ...selectedJob,
      organizationId,
    };
  } else {
    jobDetails = {
      ...details,
      organizationId,
    };
  }

  const { status } = await editJobService(authorization, jobDetails);

  if (status !== 200) {
    console.error('Error', status);
    return false;
  }
  setFlag('editJob', true);

  return true;
};

export const getPoolSize = (details) => {
  //const authorization = getAuthorization();
};

export const createJob = async () => {
  const authorization = getAuthorization();
  const { selectedJob } = getStore().job;
  const { userId } = getStore().user.details;

  const details = {
    ...selectedJob,
    userId,
  };

  const { status } = await createJobService(authorization, details);

  if (status !== 200) {
    console.error('Error', status);
    return false;
  }

  setFlag('createJob', true);
  return true;
};

export const getJobById = async (id) => {
  const authorization = getAuthorization();
  const { status, data } = await getJobByIdService(authorization, id);

  if (status !== 200) {
    console.error('Error', status);
    return false;
  }
  dispatch({
    type: SET_SELECTED_JOB,
    selectedJob: data.response,
  });
};

export const initializeJob = () => {
  const { organizationInfo } = getStore().user.details;
  dispatch({
    type: RESET_SELECTED_JOB,
    payload: {
      organizationInfo,
    },
  });
};

export const updateJob = (jobDetails) => {
  dispatch({
    type: UPDATE_SELECTED_JOB,
    jobDetails,
  });
};

export const isFiltered = (appliedFilters) => {
  const {
    from = '',
    to = '',
    jobRole = {},
    location = {},
    jobStatus = '',
  } = appliedFilters;

  return Boolean(
    from ||
      to ||
      Object.keys(jobRole).length ||
      Object.keys(location).length ||
      jobStatus
  );
};

export const addCollege = (college) => {
  dispatch({
    type: ADD_COLLEGE,
    payload: { college },
  });
};

export const removeCollege = (college) => {
  dispatch({
    type: REMOVE_COLLEGE,
    payload: { college },
  });
};

export const addDomain = (domain) => {
  dispatch({
    type: ADD_DOMAIN,
    payload: { domain },
  });
};

export const removeDomain = (domain) => {
  dispatch({
    type: REMOVE_DOMAIN,
    payload: { domain },
  });
};
